import React, { useState } from "react";

const checklistAssets = [
    {
        status: "pending",
        label: "+ add category",
        date: "25/03/2025",
        checked: false,
        detail: "ไม่สามารถกดเพิ่มรายการได้"
    },
    {
        status: "processing",
        label: "-/+ modify category",
        date: "01/04/2025",
        checked: false,
        detail: "ไม่สามารถกดแก้ไขรายการได้"
    },
    {
        status: "success",
        label: "add category",
        date: "05/04/2025",
        checked: true,
        detail: "เพิ่มรายการ category สำเร็จ"
    },
];

const checklistBackend = [
    {
        status: "pending",
        label: "add category",
        date: "25/03/2025",
        checked: false,
        detail: "This task involves creating a new category in the system."
    },
    {
        status: "success",
        label: "add category",
        date: "05/04/2025",
        checked: true,
        detail: "Category has been added successfully and verified."
    },
];
const statusColor = {
    pending: "text-warning",
    processing: "text-info",
    success: "text-success",
};

const Checklist = () => {
    const [expanded, setExpanded] = useState(null); // index of expanded item

    const toggleExpand = (index) => {
        setExpanded((prev) => (prev === index ? null : index));
    };

    return (
        <div className="container mt-4">
            <h4 className="mb-3">Requirement Checklist</h4>
            <h5 className="mb-3">Assets</h5>
            <ul className="list-group">
                {checklistAssets.map((item, index) => (
                    <li key={index} className="list-group-item">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center">
                                <span className="badge badge-secondary mr-3">{index + 1}</span>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={item.checked}
                                        readOnly
                                        id={`check-${index}`}
                                    />
                                    <label
                                        className="form-check-label ml-2"
                                        htmlFor={`check-${index}`}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => toggleExpand(index)}
                                    >
                                        {item.label}
                                    </label>
                                </div>
                            </div>
                            <div className="text-right">
                                <span className={`badge ${statusColor[item.status]} mr-2`}>
                                    {item.status}
                                </span>
                                <small className="text-muted">{item.date}</small>
                            </div>
                        </div>
                        {expanded === index && (
                            <div className="mt-2 pl-5 text-muted">
                                <small>{item.detail}</small>
                            </div>
                        )}
                    </li>
                ))}
            </ul>

            <h5 className="mb-3 mt-5">Backend</h5>
            <ul className="list-group">
                {checklistBackend.map((item, index) => (
                    <li key={index} className="list-group-item">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center">
                                <span className="badge badge-secondary mr-3">{index + 1}</span>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={item.checked}
                                        readOnly
                                        id={`check-${index}`}
                                    />
                                    <label
                                        className="form-check-label ml-2"
                                        htmlFor={`check-${index}`}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => toggleExpand(index)}
                                    >
                                        {item.label}
                                    </label>
                                </div>
                            </div>
                            <div className="text-right">
                                <span className={`badge ${statusColor[item.status]} mr-2`}>
                                    {item.status}
                                </span>
                                <small className="text-muted">{item.date}</small>
                            </div>
                        </div>
                        {expanded === index && (
                            <div className="mt-2 pl-5 text-muted">
                                <small>{item.detail}</small>
                            </div>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Checklist;
